import React from 'react';
import { MessageCircle, Heart, MoreVertical, Edit, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';

const PostCard = ({ post, onEdit, onDelete, isOwnPost = false }) => {
  const handleEdit = () => {
    if (onEdit) {
      onEdit(post);
    } else {
      toast.info('Edit post functionality coming soon!');
    }
  };

  const handleDelete = async () => {
    if (onDelete) {
      try {
        await onDelete(post.id);
        toast.success('Post deleted successfully');
      } catch (error) {
        toast.error('Failed to delete post');
      }
    }
  };

  return (
    <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
      {/* Player Header */}
      <div className="flex items-center mb-3">
        {post.user?.avatar ? (
          <img
            src={post.user.avatar}
            alt="User"
            className="w-10 h-10 rounded-full mr-3"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center mr-3">
            <span className="text-white font-bold text-sm">
              {post.user?.first_name?.[0]}{post.user?.last_name?.[0]}
            </span>
          </div>
        )}
        <div className="flex-1">
          <p className="font-medium text-gray-900">
            {post.user?.first_name} {post.user?.last_name}
          </p>
          <p className="text-sm text-gray-500">
            {new Date(post.created_at).toLocaleDateString()}
          </p>
        </div>
        <button className="text-gray-400 hover:text-gray-600">
          <MoreVertical size={16} />
        </button>
      </div>

      {/* Post Content */}
      <p className="text-sm text-gray-700 mb-3">{post.content}</p>

      {/* Social Features */}
      <div className="flex items-center space-x-4 text-sm text-gray-500">
        <button className="flex items-center hover:text-blue-600">
          <Heart size={14} className="mr-1" />
          {post.likes || 0}
        </button>
        <button className="flex items-center hover:text-blue-600">
          <MessageCircle size={14} className="mr-1" />
          {post.comments?.length || 0}
        </button>
      </div>

      {/* Action Buttons */}
      {isOwnPost && (
        <div className="mt-3 flex justify-end space-x-2">
          <button
            onClick={handleEdit}
            className="text-gray-400 hover:text-blue-600 p-1"
          >
            <Edit size={16} />
          </button>
          <button
            onClick={handleDelete}
            className="text-gray-400 hover:text-red-600 p-1"
          >
            <Trash2 size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default PostCard; 